import { render } from "./subHeader.vue?vue&type=template&id=75de86fe&ts=true"
import script from "./subHeader.vue?vue&type=script&lang=ts"
export * from "./subHeader.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__